import { ReportCardVariant } from 'shared/features/reportCard/types';

import {
  ReportGridGroup,
  ReportGridItem,
  ReportYamlGroup,
  ReportYamlItem,
} from '@/components/reports/types/report';

export const transformGroups = (groups: ReportYamlGroup[]): ReportGridGroup[] => {
  return groups.map((group: any) => {
    return {
      description: group.description,
      items: group.widgets?.map(transformWidget) || [],
      title: group.title,
    };
  });
};

export const transformWidget = (widget: ReportYamlItem): ReportGridItem => {
  return {
    baseQuery: widget.query ?? '',
    display: {
      ...(widget.display?.width && {
        widths: {
          maxWidth: widget.display?.width,
        },
      }),
      visualization: {
        ...widget.display,
        ...(widget.queries && {
          queries: widget.queries.map((query: any) => ({
            baseQuery: query.query,
            title: query.title,
          })),
        }),
      } as unknown as ReportCardVariant,
    },
    params: {},
    title: widget.title,
  };
};
